module.exports = __webpack_public_path__ + "static/media/bg-yellow.2a6bf41e.svg";